__turbopack_context__.v({
  "emptyListBodyText": "styles-module__Bd8vua__emptyListBodyText",
  "emptyListSubHeading": "styles-module__Bd8vua__emptyListSubHeading",
  "emptyListTitleContainer": "styles-module__Bd8vua__emptyListTitleContainer",
  "emptyProductList": "styles-module__Bd8vua__emptyProductList",
  "listItem": "styles-module__Bd8vua__listItem",
  "loaderWrapper": "styles-module__Bd8vua__loaderWrapper",
});
